import React, { ComponentProps, useState } from 'react';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { LazyBlock } from '../../types/api/Block';
import { NonEmptyArray } from '../../lib/typeGuards';
import ModalDialog from '../../components/organisms/ModalDialog/ModalDialog';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { BlockBar, BlockBarButton } from '../../_lib/components/BlockBar';
import { ModalDialogModifier } from '../../components/organisms/ModalDialog/ModalDialog.modifier';
import { Icons } from '../../components/atoms/SVG';
import { PageStatisticsBlock } from '../PageStatistics';

type Page = { name: string; statistics: LazyBlock<BlockType.pagestatistics> };
type SystemPageStatisticsProps = {
  pages: NonEmptyArray<Page>;
};

function SystemPageStatistics({ pages }: SystemPageStatisticsProps) {
  const { t } = useSonTranslation('SystemPageStatistics');
  const [currentPageStatistic, setCurrentPageStatistic] = useState<Page>();

  return (
    <>
      {pages.map(page => (
        <BlockBar heading={t('evaluation', { pageName: page.name })} hierarchy={3} key={page.name}>
          <BlockBarButton
            onClick={() => setCurrentPageStatistic(page)}
            svgSpriteId={Icons.ANALYSIS}
            text={`${t('title')} ${page.name}`}
          />
        </BlockBar>
      ))}
      {currentPageStatistic && (
        <ModalDialog
          modifier={ModalDialogModifier.WIDE}
          closeModal={() => setCurrentPageStatistic(undefined)}
          headline={`${t('title')} ${currentPageStatistic.name}`}
        >
          <PageStatisticsBlock {...currentPageStatistic.statistics} />
        </ModalDialog>
      )}
    </>
  );
}

export const SystemPageStatisticsBlock = asBlock(SystemPageStatistics, BlockType.systempagestatistics);
export type SystemPageStatisticsBlock = ComponentProps<typeof SystemPageStatisticsBlock>;
